import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Observable, tap } from 'rxjs';

@Injectable()
export class NetInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    console.log('➡️ HTTP Request:', req.method, req.url, req);

    const started = Date.now();

    return next.handle(req).pipe(
      tap({
        next: (event) => {
          if (event instanceof HttpResponse) {
            const elapsed = Date.now() - started;
            console.log(
              `✅ HTTP Response from ${req.url} (${elapsed} ms):`,
              event
            );
          }
        },
        error: (error) => {
          const elapsed = Date.now() - started;
          console.error(
            `❌ HTTP Error from ${req.url} (${elapsed} ms):`,
            error
          );
        },
      })
    );
  }
}
